import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import whitelist from 'assets/js/whitelist';
import * as util from 'assets/js/util';
import { validate } from 'api/system';
import fastclick from 'fastclick';
import { Alert, Confirm, Toast } from 'wc-messagebox';
import D from 'wc-messagebox';
import wxAlert from 'base/message/alert';
import wxConfirm from 'base/message/confirm';

import 'lib-flexible';

import 'assets/stylus/index.styl';
import 'wc-messagebox/style.css';

Vue.use(D);

Vue.use(Alert, {
    component: wxAlert
});

Vue.use(Confirm, {
    component: wxConfirm
});

Vue.use(Toast, {});
Vue.filter('currency', function(val) {
    return util.floatSeparator(val);
});

Vue.filter('numSeparator', function(val) {
    return util.numSeparator(val);
});
Vue.filter('formatDate', function(val) {
    return util.formatDate(val);
});
Vue.config.productionTip = false;

fastclick.attach(document.body);

router.beforeEach(async (to, from, next) => {
    //判断白名单
    if (whitelist.includes(to.path)) {
        next();
    } else if (store.state.islogined) {
        //判断vux 里面的值
        next();
    } else {
        // ajax 请求api/valid
        const logined = await validate();
        //if true  存vux next() else login
        if (logined) {
            store.commit('SET_LOGIN');
            next();
        } else {
            next({ path: '/login' });
        }
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js